import { ORGANIZATION } from "../apiConstant";
import BaseApi from "../baseApi";

class OrganizationApi extends BaseApi {
  getListChildren(param) {
    return this.post(`${ORGANIZATION}/children`, param);
  }

  search(param) {
    return this.post(`${ORGANIZATION}/search`, param);
  }
}
export default OrganizationApi;
